import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import UserPayment from 'components/payments/UserPaymentCheckout';

function mapStateToProps(state) {
  const payment = state.paymentReducer;
  return {
    subscriptionPrice: payment.get('subscriptionPrice'),
    stripePlanId: payment.get('stripePlanId'),
    stripePubKey: payment.get('stripePubKey'),
    productName: payment.get('productName'),
    accessType: payment.get('accessType'),
    userPaymentStatus: payment.get('userPaymentStatus')
  };
}
function mapDispatchToProps(dispatch) {
  return {
    actions: {
      paymentActions: bindActionCreators(require('actions/paymentActions'), dispatch)
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(UserPayment);


// WEBPACK FOOTER //
// ./src/containers/UserCheckoutContainer.js